import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText } from '@guryou/html-components';
import { getLocationInput } from 'modules/providers/containers/wizardComponents/utils';
import LocationPicker from 'onboard/components/LocationPicker';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';

import StepButtons from '../StepButtons';

const CourseLocation = () => {
  const { t } = useTranslation();
  const { courseState, setCourseState, serviceType } = useOnboardContext();

  const handleSubmit = data => {
    setCourseState({ location: getLocationInput(data) });
  };
  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.selectPreferredLocation')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <LocationPicker location={courseState.location} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText>{t('ONBOARD_TEXT.courseLocationTitle')}</MediumText>
        <DefaultText fontSize="1.2rem">{t('ONBOARD_TEXT.courseLocationSubtitle')}</DefaultText>
        <Block margin={0} marginTop={10}>
          <DefaultText fontSize="1.2rem" fontWeight="800">
            {t('ONBOARD_TEXT.courseLocationCheckboxTitle')}
          </DefaultText>
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseLocationCheckbox1Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseLocationCheckbox2Text')} />
          <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseLocationCheckbox3Text')} />
        </Block>
        <PlayGuideVideoEmbed videoId={guideVideos[`${serviceType}Location`].videoId} modalTitle={guideVideos[`${serviceType}Location`].title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default CourseLocation;
